module.exports = __webpack_public_path__ + "data/user.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/users/user.json
// module id = 8kps
// module chunks = 1